import { FC } from 'react';
import styles from './Preloader.module.scss';

/**
 * @description -  A React component that displays a loader.
 *
 * Fades in with CSS and has no exit animation (ZLAYT-1443): it is a
 * full-screen overlay, and an exit that waits for animation frames left it
 * covering the app in tabs that were not producing any.
 */

const Preloader: FC = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.spinner} />
    </div>
  );
};

export { Preloader };
